import { FormControl } from '@angular/forms';

export function isEmail(value: any) {
  return (
    typeof value === 'string' && /^[+a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(value)
  );
}

export function isMobile(value: any) {
  return (
    typeof value === 'string' && /^0{0,1}(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])[0-9]{8}$/.test(value)
  );
}

export function generateToken(size: number): string {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  return Array.from(Array(size))
    .map(() => characters.charAt(Math.floor(Math.random() * characters.length)))
    .join('');
}

/*
   校验利率百分比
*/
export function validateRate(c: FormControl) {
  const RATE_REGEXP = /^[0-9]+(.[0-9]{1,4})?$/;
  if (!c.value) {
    return null;
  }

  return RATE_REGEXP.test(c.value) ? null : { validateRate: { valid: false } };
}
